import { type LoaderFunctionArgs, Outlet, redirect } from 'react-router';

const loader = ({ params }: LoaderFunctionArgs) => {
  if (!params?.organizationId) {
    return redirect('/');
  }
  if (params?.reportId && params?.reportId !== 'new') {
    return redirect(`/o/${params?.organizationId}/reports/${params?.reportId}`);
  }
  if (!params?.reportId || params?.reportId !== 'new') {
    return redirect(`/o/${params?.organizationId}/reports/create/new`);
  }
};

export { loader as reportCreateLoader };

export const ReportCreatePage = () => {
  return <Outlet />;
};
